import { Navigate, useLocation } from 'react-router-dom';
import { isUserAuthenticated } from '@/utilities/setting';
import { ROUTES } from '@/utilities/constant';

const LOGIN_PATH = `/${ROUTES.LOGIN}`;

/**
 * Redirects unauthenticated users to the login page while preserving the
 * intended destination as ?from=… so we can bounce back after a successful login.
 *
 * Checks the same session source the real login flow writes to
 * (Storage['access_token'] via utilities/setting.ts) — not the unused
 * Zustand auth store, which real logins never populate.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthed = Boolean(isUserAuthenticated());
  const location = useLocation();

  if (!isAuthed) {
    return <Navigate to={LOGIN_PATH} state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

/** Inverse — bounces authed users away from the login page. */
export function RedirectIfAuthed({ children }: { children: React.ReactNode }) {
  const isAuthed = Boolean(isUserAuthenticated());
  if (isAuthed) return <Navigate to="/" replace />;
  return <>{children}</>;
}
